// Thin adapter that returns an ETA window ({from, to}) for a product handle.
// Path B integration (see PROMPT OPTION-2 STEP 1): the underlying window is
// computed by getPreorderWindow(today) in lib/preorder.js. This file exposes
// a getEta(handle) shape so pages / cards can rebind without knowing the
// helper's internals.
//
// Rules:
//   - Only returns a window when the product is in the pre-order state.
//     Callers pass an isPreorder boolean so we don't re-derive it here.
//   - Returns null for in-stock products (spec §T5: renders nothing).

import { getPreorderWindow } from '../lib/preorder';

export function getEta(handle, { isPreorder = false, today } = {}) {
        if (!handle) return null;
        if (!isPreorder) return null;
        const { start, end } = getPreorderWindow(today || new Date());
        return { from: start, to: end };
}

export default getEta;
